/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import PropTypes from 'prop-types'

const CuratorsPlaylistActivity = props => {
  // eslint-disable-next-line no-console
  console.log('CuratorsPlaylistActivity')
  return <div>Hello CuratorsPlaylistActivity</div>
}

CuratorsPlaylistActivity.propTypes = {}

export default CuratorsPlaylistActivity
